module.exports = __webpack_public_path__ + "ofis 7.jpg?73e6f835a8c3ba92eedfbda2db5bee15";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/ofis 7.jpg
// module id = 359
// module chunks = 0